import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FourSectionStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import replaceHttpToHttps from '@src/utils/replace-url-to-https';

const styles = require('./index.less');
// console.log(styles);
/**
 * FourSection
 * @param store {FourSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FourSection = ({ store }) => {
  store.use();
  // console.log(store.list);
  // console.log(store.currentContent);
  // console.log(store.currentIndex);

  // 坐标锚点部分
  const anchorPointPart = () => {
    return (
      <React.Fragment>
        {/* 5个坐标 */}
        {store.list?.map((item, index) => {
          return (
            <div
              key={index}
              className={cx(styles.anchorPoint, styles['anchorPoint' + item.id], !store.isMapClick && styles.anchorPointAct)}
              data-name={item.name}
              onMouseEnter={() => {
                store.mouseMove(item.id);
              }}
              onMouseOut={() => {
                store.mouseMove(0);
              }}
              onClick={() => {
                store.clickIndex(item.id);
              }}
            >
              <div className={cx(styles.tipsClickToVve, store.hoverIndex === item.id && styles.tipsClickToVveAct)} />
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  // hover节点图部分
  const hoverImgPart = () => {
    return (
      <React.Fragment>
        <Link
          className={cx(styles.partialSelectioniMG, styles['hoverImg' + store.hoverIndex])}
          onMouseEnter={() => {
            store.mouseMove(store.hoverIndex);
          }}
          onMouseLeave={() => {
            store.mouseOut();
          }}
          onClick={() => {
            store.clickIndex(store.hoverIndex);
          }}
        >
          {' '}
        </Link>
      </React.Fragment>
    );
  };
  // hover节点图部分
  const renderHoverImaPart = () => {
    return (
      <div className={styles.hoverImaPartBox}>
        {store.list.map((item, index) => {
          return (
            <div key={index} className={cx(styles.partialSelectioniMG, styles['hoverImg' + item.id], store.hoverIndex === item.id && styles.hoverImgActive)} />
          );
        })}
      </div>
    );
  };

  // 特写图部分
  const detailMpaImgPart = () => {
    return (
      <div
        className={cx(styles.detailMpaImg)}
        style={{ backgroundImage: `url(${replaceHttpToHttps(store.list[store.currentIndex - 1]?.detailImg)})` }}
        data-name="特写图"
      >
        <div
          className={cx(styles.detailMpaImg_screen_bg1, !store.detailMpaImgLoadState && styles.detailMpaImg_screen_act)}
          style={{ backgroundImage: `url(${replaceHttpToHttps(store.list[store.currentIndex - 1]?.detailImg)})` }}
        />
        <div
          className={cx(styles.detailMpaImg_screen_bg2, !store.detailMpaImgLoadState && styles.detailMpaImg_screen_act)}
          style={{ backgroundImage: `url(${replaceHttpToHttps(store.list[store.currentIndex - 1]?.detailImg)})` }}
        />
        <div
          className={cx(styles.detailMpaImg_screen_bg3, !store.detailMpaImgLoadState && styles.detailMpaImg_screen_act)}
          style={{ backgroundImage: `url(${replaceHttpToHttps(store.list[store.currentIndex - 1]?.detailImg)})` }}
        />
      </div>
    );
  };

  // 副本标记
  const dungeonPointsPart = () => {
    return (
      <div className={cx(styles.dungeonPoints__show, store.isMapClick && styles.dungeonPoints__hide)}>
        <div className={styles.dungeonPoints} />
        <div className={styles.dungeonPointsText} />
      </div>
    );
  };

  return (
    <div className={cx(styles.fourSectionRoot)}>
      <div className={cx(styles.fourSectionBox, store.isMapClick && styles.detailMpaActive)}>
        <div className={styles.decorate} data-name="装饰">
          {/* <div className={styles.decorate_text} data-name="玛斯马克地形">
            玛斯马克地形
          </div> */}
        </div>
        <div className={cx(styles.gameMapBox)} data-name="初始地图盒子">
          {/*TODO: 后续删除这个部分, 大地图全程保持即可, 这样退出也能有一个回收的动画 */}
          {/*{!store.detailMpaImgLoadState && (*/}
          {/*  <div className={cx(styles.bg, store.isMapClick && styles['bg_focusEffect' + store.currentIndex])}*/}
          {/*       data-name="初始地图" />*/}
          {/*)}*/}
          <div className={cx(styles.bg, store.isMapClick && styles['bg_focusEffect' + store.currentIndex])} data-name="初始地图" />
          <div className={cx(styles.xiaozi, store.isMapClick && styles['bg_focusEffect' + store.currentIndex])} />
          {/* 副本标记 */}
          {dungeonPointsPart()}
          {/* 地图节点 */}
          {anchorPointPart()}
          {/* 选中hover效果 */}
          {/*{hoverImgPart()}*/}
          {renderHoverImaPart()}
          {/* 特写图 */}
          {detailMpaImgPart()}
          {/* 调试特写图和放大地图贴合效果 */}
          {/*{store.isMapClick && (*/}
          {/*  <div className={cx(styles.test111)} style={{ backgroundImage: `url(${replaceHttpToHttps(store.list[store.currentIndex - 1]?.detailImg)})` }} />*/}
          {/*)}*/}
        </div>
        {/* 弹窗信息内容 */}
        <div className={cx(styles.infoModalBox, store.isMapClick && styles.infoModalBoxAct)}>
          {/* 地图标题 */}
          <div className={cx(styles.detailMpaTitleBox)}>
            <div className={styles.titleBox}>
              <div className={styles.title1}>{store.list[store.currentIndex - 1]?.name}</div>
              <div className={styles.title2}>{store.list[store.currentIndex - 1]?.enName}</div>
            </div>
          </div>
          {/* info 弹窗 */}
          <div className={cx(styles.detailMpaInfoBox)}>
            <Link
              className={cx(styles.close)}
              onClick={() => {
                store.close();
              }}
            />
            <div className={cx(styles.contentIndex)}>0{store.currentContentIndex + 1}</div>
            <div className={cx(styles.contentTitleBox)}>
              <div className={cx(styles.contentTitle1)}>{store.currentContent[store.currentContentIndex]?.name}</div>
              <div className={cx(styles.contentTitle2)}>{store.currentContent[store.currentContentIndex]?.englishTitle?.toUpperCase()} </div>
            </div>
            <div className={cx(styles.line)} />
            <div
              className={cx(styles.coverImage)}
              style={{ backgroundImage: `url(${replaceHttpToHttps(store.currentContent[store.currentContentIndex]?.content_img)})` }}
            >
              <Link
                className={cx(styles.enlargeBtn)}
                onClick={() => {
                  store.openExpandImage(store.currentContent[store.currentContentIndex]?.content_img, store.currentContent[store.currentContentIndex]?.name);
                }}
              />
            </div>

            <div className={cx(styles.contentText)} id="mapContentText">
              {store.currentContent[store.currentContentIndex]?.content}
            </div>
            <div className={cx(styles.tabBox, styles['area' + store.currentIndex])}>
              {store.currentContent?.map((item, index) => {
                if (item.type === 'unknown') {
                  return (
                    <div key={index} className={styles.tabUnknown}>
                      <div className={cx(styles.tabName)}>{item.name}</div>
                    </div>
                  );
                }
                return (
                  <Link
                    key={index}
                    className={cx(styles.tabItem, store.currentContentIndex === index && styles.active)}
                    onClick={() => {
                      store.tabClick(index);
                    }}
                  >
                    <span>0{index + 1}</span>
                    <div className={cx(styles.tabName)}>{item.name}</div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FourSection, FourSectionStore);
